export interface faturasProps {
	codigo: string | null;
	invoice: number;
	urlcodigobarras?: null | string;
	pdf: string;
}
export interface changePaymentMethodProps {
	status: string;
	code: number;
	message: string;
	faturas: faturasProps[];
}

export interface lastDataWhiteListProps {
	ID_RESPOSTA_WHITELIST: number;
	ID_FATURA: string;
	RESPOSTA_WHITELIST_VALOR: string;
	RESPOSTA_WHITELIST_CRIADO: string;
}

export interface AnswerNpsProps {
	RESPOSTA_NPS_TRIMESTRE: string;
	RESPOSTA_NPS_VALOR_1: string;
	RESPOSTA_NPS_VALOR_2: string;
	RESPOSTA_NPS_CRIADO: string;
}

export type BillingCycle =
	| "month"
	| "quarter"
	| "semester"
	| "year"
	| "biannual";

export type ServiceType = "boolean" | "cycle" | "limit" | "options";

export interface Plan {
	id: number;
	name: string;
	name_indentification: string;
	description: string;
	price_cents: string;
	billing_cycle: BillingCycle;
	created_at: string;
	plan_id_erp: number | null;
}

export enum PlanIds {
	FREE = "free",
	KINOLOGY_STARTER = "kinology_starter",
	KINOLOGY_PRO = "kinology_pro",
	KINOLOGY_PREMIUM = "kinology_premium",
	INFINITY = "infinity",
	EMPRESAS_PLUS = "empresas_plus",
	EMPRESAS_2024 = "empresas_2024",
	ESPECIALISTA_2023 = "especialista_2023",
	KINOLOGY_PRO_ANUAL = "kinology_pro_anual",
	OURO_2020 = "2020_ouro",
	KINOLOGY_PERSONALIZADO = "kinology_personalizado",
	ESPECIALISTA_PREMIUM = "especialista_premium",
	BLACKOUT = "blackout",
	ESPECIALISTA_2024 = "especialista_2024",
	ESPECIALISTA = "especialista",
	RETENCAO_INFINITY = "retencao_infinity",
	CLINICAS = "clinicas",
	KINOLOGY_PREMIUM_TRIMESTRAL = "kinology_premium_trimestral",
	KINOLOGY_PREMIUM_SEMESTRAL = "kinology_premium_semestral",
	KINOLOGY_PRO_SEMESTRAL = "kinology_pro_semestral",
	KINOLOGY_PRO_TRIMESTRAL = "kinology_pro_trimestral",
	KINOLOGY_STARTER_TRIMESTRAL = "kinology_starter_trimestral",
	KINOLOGY_STARTER_SEMESTRAL = "kinology_starter_semestral",
	LIGHT = "light",
	PRATA_2020 = "2020_prata",
	ESPECIALISTA_BASIC = "especialista_basic",
	PRO_E_LASTIC = "E-lastic_200",
	PRATA_PLUS = "4q2021_prata_25990",
	RETENCAO_LIGHT = "retencao_light",
	EMPRESAS_BASIC = "empresas_basic",
	DIAMANTE = "4q2021_diamante_32990",
	AVALIADOR = "avaliador",
	ESPECIALISTA_PREMIUM_BIANUAL = "especialista_premium_bianual",
}

export interface Service {
	service: string;
	type: ServiceType;
	description: string;
	value: string | string[];
}
export interface Subscription {
	id: number;
	user_id: number;
	plan_id: number;
	status: "active" | "trial" | "inactive" | "pending" | "canceled" | "expired";
	substitute_entitlement: string;
	id_subscription_erp: string | number | null;
	started_at: string;
	expires_at: string;
	created_at: string;
	last_sincronization: string;
	services: Service[];
	registred_evaluators: number;
	registred_uni_complete_report: number;
	registred_palm_report: number;
}
